import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetDressCodePicturesAction } from '../../actions/dress-code-pictures/get-dress-code-pictures-action';
import { AddDressCodePictureAction } from '../../actions/dress-code-pictures/add-dress-code-picture-action';
import { AddDressCodePictureErrorAction } from '../../actions/dress-code-pictures/add-dress-code-picture-error-action';

@Injectable()
export class AddDressCodePictureEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public AddDressCodePicture = createEffect(() => this.actions
    .pipe(
      ofType(AddDressCodePictureAction.type),
      mergeMap(action => {
        const addDressCodePictureAction = <AddDressCodePictureAction>action;
        return this.api.addDressCodePicture(addDressCodePictureAction.bijbEvent, addDressCodePictureAction.dressCodePicture).then(() => {
          return new GetDressCodePicturesAction(addDressCodePictureAction.bijbEvent);
        }, error => {
          return new AddDressCodePictureErrorAction(error);
        });
      })
    ));
}
